/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Grid, Container } from '@mui/material';
import { AppGraphs, AppWidgetSummary } from '../../../sections/dashboard/dash';
import { selectLogin } from '../../../../store/login/loginSlice';
import { useSelector } from 'react-redux';
import { NotificationManager } from 'react-notifications';

import configAxios from '../../../../services/configAxios';
import RenderPage from '../../../layouts/RenderPage';

const DashboardApp = () => {
  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });
  const [InfosSummaryUserActive, setInfosSummaryUserActive] = useState(0);
  const [InfosSummaryUserBlock, setInfosSummaryUserBlock] = useState(0);
  const [InfosSummaryEstablishmentsActive, setInfosSummaryEstablishmentsActive] = useState(0);
  const [InfosSummaryTokensDay, setInfosSummaryTokensDay] = useState(0);
  const [InfosSummaryTokensMonth, setInfosSummaryTokensMonth] = useState(0);
  const [infosLabelsGraphsUsers, setInfosLabelGraphsUsers] = useState([]);
  const [infosDataGraphsUsers, setInfosDataGraphsUsers] = useState([]);
  const [InfosLabelGraphsTokens, setInfosLabelGraphsTokens] = useState([]);
  const [InfosDataGraphsTokens, setInfosDataGraphsTokens] = useState([]);

  useEffect(() => {
    Promise.all([
      getInfosSummaryUserActive(),
      getInfosSummaryUserBlock(),
      getInfosSummaryEstablishmentsActive(),
      getInfosGraphUserActive(),
      getInfosSummaryTokensMonth()
    ]);
    if (infoState.id_type_user === 2) {
      Promise.all([
        // Parceitos
        getInfosGraphTokensUsedYear(),
        getInfosSummaryTokensDay()
      ]);
    }
  }, []);

  // Novos itens dos graficos
  // Tokens Validados por Mes
  async function getInfosSummaryTokensMonth() {
    let url = '/dashboard/getInfosSummaryTokensMonth';

    if (infoState.id_type_user !== 1) {
      url = `${url}/${infoState.id_establishment}`;
    }
    configAxios
      .get(`${url}`)
      .then((response) => setInfosSummaryTokensMonth(response.data[0].count))
      .catch((error) =>
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre as Tokens por mês! Tente novamente!',
          'Atenção'
        )
      );
  }

  // Tokens Validados no dia
  async function getInfosSummaryTokensDay() {
    let url = '/dashboard/getInfosSummaryTokensDay';

    if (infoState.id_type_user !== 1) {
      url = `${url}/${infoState.id_establishment}`;
    }

    configAxios
      .get(`${url}`)
      .then((response) => setInfosSummaryTokensDay(Number(response.data[0].count)))
      .catch((error) =>
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre os tokens! Tente novamente!',
          'Atenção'
        )
      );
  }

  // Usuarios Ativos
  async function getInfosSummaryUserActive() {
    let url = '/dashboard/getInfosSummaryUsers';

    configAxios
      .get(`${url}`)
      .then((response) => setInfosSummaryUserActive(Number(response.data[0].count)))
      .catch((error) =>
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre os usuários ativos! Tente novamente!',
          'Atenção'
        )
      );
  }

  // Usuarios Bloqueados
  async function getInfosSummaryUserBlock() {
    let url = '/dashboard/getInfosSummaryUsersBlocked';

    configAxios
      .get(`${url}`)
      .then((response) => setInfosSummaryUserBlock(Number(response.data[0].count)))
      .catch((error) =>
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre os usuários bloqueados! Tente novamente!',
          'Atenção'
        )
      );
  }

  // Parceiros Ativos
  async function getInfosSummaryEstablishmentsActive() {
    let url = '/dashboard/getInfosSummaryEstablishments';

    configAxios
      .get(`${url}`)
      .then((response) => setInfosSummaryEstablishmentsActive(Number(response.data[0].count)))
      .catch((error) =>
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre os parceiros ativos! Tente novamente!',
          'Atenção'
        )
      );
  }

  // Grafico Usuarios Ativos
  async function getInfosGraphUserActive() {
    let router;
    router = '/dashboard/getInfosGraphUsers';

    await configAxios
      .get(router)
      .then((response) => {
        const labels = [];
        const data = [];

        response.data.map((element) => {
          labels.push(element.day);
        });

        response.data.map((element) => {
          data.push(element.dia);
        });

        setInfosLabelGraphsUsers(labels);
        setInfosDataGraphsUsers(data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre os usuários! Tente novamente!',
          'Atenção'
        );
      });
  }

  // Grafico Tokens Utilizados por ano
  async function getInfosGraphTokensUsedYear() {
    let router = `/dashboard/getInfosGraphTokens/${infoState.id_establishment}`;

    await configAxios
      .get(router)
      .then((response) => {
        const labels = [];
        const data = [];

        response.data.map((element) => {
          labels.push(element.day);
        });

        response.data.map((element) => {
          data.push(element.dia);
        });

        setInfosLabelGraphsTokens(labels);
        setInfosDataGraphsTokens(data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações sobre os tokens! Tente novamente!',
          'Atenção'
        );
      });
  }

  return (
    <RenderPage title="Dashboard">
      <Container maxWidth="xl">
        {/* Type user 1 - ADM, 2 - Partners, id_profile = 3 Establishment ( possui menos opções ) */}
        {infoState.id_type_user === 1 ? (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Associados ativos"
                total={Number(InfosSummaryUserActive)}
                icon={'eva:person-done-outline'}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Associados cadastrados"
                total={Number(InfosSummaryUserBlock)}
                icon={'eva:person-add-outline'}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Parceiros cadastrados"
                total={Number(InfosSummaryEstablishmentsActive)}
                icon={'eva:people-outline'}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppWidgetSummary
                title="Tokens validados no mês"
                total={Number(InfosSummaryTokensMonth)}
                icon={'ant-design:file-done-outlined'}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <AppGraphs
                title="Cadastros de associados realizadas por período"
                subheader="Acompanhe o desempenho dos cadastros de associados no último ano separadas por período"
                chartLabels={infosLabelsGraphsUsers}
                name="Associados ativos"
                chartData={[
                  {
                    name: 'Associados ativos',
                    type: 'line',
                    fill: 'solid',
                    data: infosDataGraphsUsers
                  }
                ]}
              />
            </Grid>
          </Grid>
        ) : infoState.id_profile === 3 ? (
          <Grid container spacing={2}>
            <Grid item xs={14} sm={6} md={6}>
              <AppWidgetSummary
                title="Tokens validados hoje"
                total={Number(InfosSummaryTokensDay)}
                icon={'ant-design:file-done-outlined'}
              />
            </Grid>
            <Grid item xs={14} sm={10} md={6}>
              <AppWidgetSummary
                title="Tokens validados este mês"
                total={InfosSummaryTokensMonth}
                icon={'ant-design:exception-outlined'}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={14} sm={6} md={6}>
              <AppWidgetSummary
                title="Tokens validados hoje "
                total={Number(InfosSummaryTokensDay)}
                icon={'ant-design:file-done-outlined'}
              />
            </Grid>
            <Grid item xs={14} sm={10} md={6}>
              <AppWidgetSummary
                title="Tokens validados este mês"
                total={Number(InfosSummaryTokensMonth)}
                icon={'ant-design:exception-outlined'}
              />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <AppGraphs
                title="Tokens validados no ano"
                subheader="Acompanhe o desempenho do seu estabelecimento este mês"
                chartLabels={InfosLabelGraphsTokens}
                name="Tokens Validados"
                chartData={[
                  {
                    name: 'Tokens Validados',
                    type: 'line',
                    fill: 'solid',
                    data: InfosDataGraphsTokens
                  }
                ]}
              />
            </Grid>
          </Grid>
        )}
      </Container>
    </RenderPage>
  );
};

export default DashboardApp;
